import React, {Component} from 'react';
import './ProgressBar.css';
import PropTypes from 'prop-types';
import {Progress} from 'reactstrap';
import _ from 'lodash';

class ProgressBar extends Component {
    constructor(props) {
        super(props);

        this.state = {            
            max: this.props.total || (this.props.left + this.props.validated)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.total !== nextProps.total && !_.isNil(nextProps.total)) {
            this.setState({ max: nextProps.total });
        } else if (_.isNil(this.props.left) && !_.isNil(nextProps.left)) {
            this.setState({max: nextProps.left + nextProps.validated});
        }
    }

    render() {
        return (
            <div className='accreditations-validation-progress-container'>
                <span className="accreditations-validation-progress-label">{this.props.label}</span>
                <Progress multi>                    
                    <Progress bar color="secondary" max={this.state.max} value={this.props.skipped} >{this.props.skipped > 0 ? this.props.skipped : ''}</Progress>
                    <Progress bar color="primary" max={this.state.max} value={this.props.validated} >{this.props.validated > 0 ? this.props.validated : ''}</Progress>
                </Progress>
            </div>
        );
    }
}

ProgressBar.propTypes = {
    left: PropTypes.number,
    validated: PropTypes.number,
    skipped: PropTypes.number,
    label: PropTypes.string
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/commonComponents/progressBar/ProgressBar.js